import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { Alert } from 'react-magma-dom';
import * as React from 'react';
export default {
  Link,
  Alert,
  React
};